import thunk from 'redux-thunk'
import { combineReducers, createStore as _createStore, applyMiddleware } from 'redux'

import valentine from './reducers/valentine'
import loading from './reducers/loading'
import ageRange from './reducers/ageRange'
import votes from './reducers/votes'
import wallet from './reducers/wallet'

export default function createStore(initialState) {

  const app = combineReducers({
    valentine,
    loading,
    ageRange,
    votes,
    wallet
  })

  const createStoreWithMiddleware = applyMiddleware(thunk)(_createStore)
  return createStoreWithMiddleware(app, initialState)
}
